import '../../../../../../common/FileUploader/FileUploader.scss';
import './FileDropzone.scss';

import { IconUpload } from '@hulu-react-style-components/icons';
import React from 'react';
import type { DropzoneRootProps } from 'react-dropzone';

import InfoSection from '../../../../../../common/FileUploader/InfoSection/InfoSection';
import ProgressContainer from '../../../../../../common/FileUploader/ProgressContainer/ProgressContainer';
import bem from '../../../../../../utils/bem';

const [, fileUploaderElement] = bem('file-uploader');
const [block, element] = bem('file-dropzone');

export type FileDropzoneProps = {
  title: string;
  uploadMessage: string;
  dropText: string;
  fileLabel: string;
  infoText: string;
  formatLabel: string;
  hovering: boolean;
  loading: boolean;
  percentUploaded?: number;
  cancelRequest: () => void;
  fileAddedName: string | null;
  getRootProps: (props?: object) => DropzoneRootProps;
  getInputProps: () => object;
};

const FileDropzone = ({
  title,
  uploadMessage,
  dropText,
  fileLabel,
  infoText,
  formatLabel,
  hovering,
  loading,
  percentUploaded,
  cancelRequest,
  fileAddedName,
  getRootProps,
  getInputProps,
}: FileDropzoneProps): React.JSX.Element => {
  return (
    <div data-testid="file-dropzone" className={block()}>
      <p className={element('title')}>{title}</p>
      <div className={element('upload-container')}>
        {loading ? (
          <ProgressContainer
            cancelRequest={cancelRequest}
            uploadMessage={<>{uploadMessage}</>}
            percentUploaded={percentUploaded}
          />
        ) : (
          <div
            data-testid="drop-input"
            {...getRootProps({ className: fileUploaderElement('dropzone', hovering ? 'hovering' : '') })}
          >
            <input aria-label="file drag and drop" {...getInputProps()} />
            {fileAddedName ? (
              <div className={element('uploaded-file-name')}>
                <p className={fileUploaderElement('head-info')}>
                  {fileLabel} <strong>{fileAddedName}</strong>
                </p>
              </div>
            ) : (
              <p className={fileUploaderElement('head-info')}>{dropText}</p>
            )}
            <div className={fileUploaderElement('select-container')}>
              <button data-testid="my-device-upload" type="button" className={fileUploaderElement('select-button')}>
                <IconUpload title="upload icon" />
                <span>My Device</span>
              </button>
            </div>
            <InfoSection
              mainInfo={infoText}
              formatDimensionLabels={{
                format: formatLabel,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FileDropzone;
